import React, {FC, useState} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownHeader} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownHeader';
import {DropdownList} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemChevron} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemChevron';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {FilterDropdownRenderer} from '../../../../components/common/filters/moreFiltersDropdown/moreFiltersDropdown';
import {
  LiveDashboardAssignedByTeammateStatusDropdown,
  SelectableStatusesEnum,
} from './liveDashboardAssignedByTeammateStatusDropdown';

/*
 * Props.
 */

interface LiveDashboardAssignedByTeammateFiltersDropdownProps {
  resolvedTeammatesCount: number;

  statusSelection: Set<SelectableStatusesEnum>;
  onStatusesSelection: (selection: Set<SelectableStatusesEnum>) => void;

  renderTeammatesDropdown: FilterDropdownRenderer;
  popoverProps: PopoverTransferProps;
}

/*
 * Component.
 */

export const LiveDashboardAssignedByTeammateFiltersDropdown: FC<
  LiveDashboardAssignedByTeammateFiltersDropdownProps
> = (props) => {
  const {
    resolvedTeammatesCount,
    statusSelection,
    popoverProps,
    onStatusesSelection,
    renderTeammatesDropdown,
  } = props;

  const [step, setStep] = useState(StepsEnum.ROOT);
  const selectedStatusesCount = statusSelection.size;

  const renderRootDropdown = () => (
    <Dropdown {...popoverProps} width={250}>
      <DropdownHeader title={<Trans id="live-dashboard-assigned-by-teammate-filter-by">Filter by</Trans>} />
      <DropdownList>
        <DropdownItem onSelect={() => setStep(StepsEnum.TEAMMATES)}>
          <DropdownItemContent>
            <Trans id="live-dashboard-assigned-by-teammate-filter-teammates">
              Teammates ({resolvedTeammatesCount})
            </Trans>
          </DropdownItemContent>
          <DropdownItemChevron />
        </DropdownItem>
        <DropdownItem onSelect={() => setStep(StepsEnum.STATUSES)}>
          <DropdownItemContent>
            <Trans id="live-dashboard-assigned-by-teammate-filter-status">
              Status ({selectedStatusesCount})
            </Trans>
          </DropdownItemContent>
          <DropdownItemChevron />
        </DropdownItem>
      </DropdownList>
    </Dropdown>
  );

  const renderStatusesDropdown = () => (
    <LiveDashboardAssignedByTeammateStatusDropdown
      selection={statusSelection}
      onBackClick={() => setStep(StepsEnum.ROOT)}
      onStatusesSelection={onStatusesSelection}
      popoverProps={popoverProps}
    />
  );

  switch (step) {
    case StepsEnum.ROOT:
      return renderRootDropdown();

    case StepsEnum.TEAMMATES:
      return renderTeammatesDropdown(popoverProps);

    case StepsEnum.STATUSES:
      return renderStatusesDropdown();

    default:
      return null;
  }
};

enum StepsEnum {
  ROOT = 'root',
  TEAMMATES = 'teammates',
  STATUSES = 'statuses',
}
